import { AfterViewInit, Directive } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PopupMessage } from 'src/app/core';
import { AuthService } from '../service/auth.service';
import { IAuthForm, IAuthLayoutConfig } from './auth.model';

@Directive()
export class Auth implements AfterViewInit {
	authForm: IAuthForm = {
		formGroup: new UntypedFormGroup({}),
		model: {},
		fields: []
	};
	layoutConfig: IAuthLayoutConfig = {
		oauth: false,
		custom_sign_into_text: '',
		login_welcome_message: '',
		portalName: '',
		logo_alt: 'logo',
		allow_user_to_self_register: false
	};

	constructor(
		public authService: AuthService,
		public toastrService: ToastrService,
		public translateService: TranslateService
	) {}

	ngAfterViewInit(): void {
		this.handleToastrMessages();
	}

	private handleToastrMessages(): void {
		if (!!this.authService.toastrMessages && this.authService.toastrMessages.length) {
			this.authService.toastrMessages.forEach((item: PopupMessage) => {
				this.toastrService[item.type](this.translateService.instant(item.message));
			});
			this.authService.toastrMessages = [];
		}
	}
}
